<ds-modal
  class="modal-container"
  [headerIcon]="Icons.Bars"
  [modal]="modal"
  [title]="'menu' | translate"
  [colorVariant]="DsModalColorVariant.Default"
>
  <div class="navigation-content">
    <vertical-navigation
      [isCollapsed]="false"
      [showMobileAccountSection]="true"
      (menuItemClicked)="onMenuItemClick()"
    ></vertical-navigation>
  </div>
</ds-modal>
